import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { DividerItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/dividerItemAttributes';

import Container from './Container';
import Divider from './Divider';

const DividerSettings = ({
  defaultAttributes,
  item,
  onChange,
  permissions,
}: ComponentSettingsTab<DividerItemAttributes>) => {
  const settingProps = {
    defaultAttributes,
    item,
    onChange,
    permissions,
  };

  return (
    <Wrapper>
      <Divider {...settingProps} />
      <Container {...settingProps} />
    </Wrapper>
  );
};

export default DividerSettings;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  mt: '10px',
  width: '100%',
}))``;
